module.exports = __webpack_public_path__ + "img/row-x.e73ecbb3.svg";